"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _react = _interopRequireWildcard(require("react"));
var _ImageCardCore = _interopRequireDefault(require("./ImageCardCore"));
var _helpers = require("../../utils/helpers");
var _ImageCardModule = _interopRequireDefault(require("./../../scss/blocks/ImageCard.module.scss"));
const ImageCard = /*#__PURE__*/(0, _react.forwardRef)(function ImageCard(props, ref) {
  const {
    image = {
      url: '',
      altText: '',
      aspectRatio: 1,
      sources: []
    },
    mobileImage = {
      url: '',
      altText: '',
      aspectRatio: 1
    },
    fullSizeImagePosition = [50, 50],
    mobileImagePosition = [50, 50],
    clampContentLines = true,
    numberOfLinesToClamp = 3,
    overlayPosition = "left",
    overlayTextColor = "#fff",
    relatedResourceId = "",
    cta = {
      label: '',
      href: '',
      type: '',
      relatedResourceId: '',
      relatedResourceType: '',
      position: 'end'
    },
    handleClicks = () => {},
    fullCardClickable = false,
    displayInline = false,
    classname = ''
  } = props;
  const overlayPostionsMap = new Map([['left', 'flex-start'], ['right', 'flex-end'], ['center', 'center']]);
  const handleCardClicked = e => {
    handleClicks({
      type: 'card-clicked',
      ctaType: cta === null || cta === void 0 ? void 0 : cta.type,
      resourceId: relatedResourceId,
      resourceType: cta.relatedResourceType,
      target: e.target,
      currentTarget: e.currentTarget
    });
  };
  if (fullCardClickable && (cta === null || cta === void 0 ? void 0 : cta.href) !== '' && ((cta === null || cta === void 0 ? void 0 : cta.type) === 'internal-link' || (cta === null || cta === void 0 ? void 0 : cta.type) === 'external-link')) {
    var _fullSizeImagePositio, _fullSizeImagePositio2, _mobileImagePosition$, _mobileImagePosition$2;
    return /*#__PURE__*/_react.default.createElement("image-card", {
      class: (0, _helpers.classes)([fullCardClickable ? _ImageCardModule.default['image-card--clickable'] : null, displayInline ? _ImageCardModule.default['image-card--inline'] : null, classname]),
      style: {
        '--justify-overlay-content': overlayPostionsMap.get(overlayPosition),
        '--align-overlay-content': displayInline ? 'center' : 'flex-end',
        '--overlay-content-text-color': overlayTextColor,
        '--content-line-clamp': clampContentLines ? numberOfLinesToClamp : 'unset',
        '--image-aspect-ratio': image.aspectRatio,
        '--mobile-image-aspect-ratio': mobileImage.aspectRatio,
        '--background-image-position': "".concat((_fullSizeImagePositio = fullSizeImagePosition === null || fullSizeImagePosition === void 0 ? void 0 : fullSizeImagePosition[0]) !== null && _fullSizeImagePositio !== void 0 ? _fullSizeImagePositio : '50', "% ").concat((_fullSizeImagePositio2 = fullSizeImagePosition === null || fullSizeImagePosition === void 0 ? void 0 : fullSizeImagePosition[1]) !== null && _fullSizeImagePositio2 !== void 0 ? _fullSizeImagePositio2 : '50', "%"),
        '--mobile-background-image-position': "".concat((_mobileImagePosition$ = mobileImagePosition === null || mobileImagePosition === void 0 ? void 0 : mobileImagePosition[0]) !== null && _mobileImagePosition$ !== void 0 ? _mobileImagePosition$ : '50', "% ").concat((_mobileImagePosition$2 = mobileImagePosition === null || mobileImagePosition === void 0 ? void 0 : mobileImagePosition[1]) !== null && _mobileImagePosition$2 !== void 0 ? _mobileImagePosition$2 : '50', "%")
      },
      onClick: fullCardClickable ? handleCardClicked : () => true,
      "data-cursor": "pointer"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: cta.href,
      title: image === null || image === void 0 ? void 0 : image.altText,
      target: cta.type === 'external-link' ? '_blank' : '_self',
      rel: cta.type === 'external-link' ? 'noreferrer' : null,
      className: "image-card__full-card-link"
    }, /*#__PURE__*/_react.default.createElement(_ImageCardCore.default, (0, _extends2.default)({}, props, {
      styles: _ImageCardModule.default,
      ref: ref
    }))));
  } else {
    var _fullSizeImagePositio3, _fullSizeImagePositio4, _mobileImagePosition$3, _mobileImagePosition$4;
    return /*#__PURE__*/_react.default.createElement("image-card", {
      class: (0, _helpers.classes)([displayInline ? _ImageCardModule.default['image-card--inline'] : null, classname]),
      style: {
        '--justify-overlay-content': overlayPostionsMap.get(overlayPosition),
        '--align-overlay-content': displayInline ? 'center' : 'flex-end',
        '--overlay-content-text-color': overlayTextColor,
        '--content-line-clamp': clampContentLines ? numberOfLinesToClamp : 'unset',
        '--image-aspect-ratio': image.aspectRatio,
        '--mobile-image-aspect-ratio': mobileImage.aspectRatio,
        '--background-image-position': "".concat((_fullSizeImagePositio3 = fullSizeImagePosition === null || fullSizeImagePosition === void 0 ? void 0 : fullSizeImagePosition[0]) !== null && _fullSizeImagePositio3 !== void 0 ? _fullSizeImagePositio3 : '50', "% ").concat((_fullSizeImagePositio4 = fullSizeImagePosition === null || fullSizeImagePosition === void 0 ? void 0 : fullSizeImagePosition[1]) !== null && _fullSizeImagePositio4 !== void 0 ? _fullSizeImagePositio4 : '50', "%"),
        '--mobile-background-image-position': "".concat((_mobileImagePosition$3 = mobileImagePosition === null || mobileImagePosition === void 0 ? void 0 : mobileImagePosition[0]) !== null && _mobileImagePosition$3 !== void 0 ? _mobileImagePosition$3 : '50', "% ").concat((_mobileImagePosition$4 = mobileImagePosition === null || mobileImagePosition === void 0 ? void 0 : mobileImagePosition[1]) !== null && _mobileImagePosition$4 !== void 0 ? _mobileImagePosition$4 : '50', "%")
      },
      onClick: fullCardClickable ? handleCardClicked : () => true,
      "data-cursor": fullCardClickable ? 'pointer' : 'default'
    }, /*#__PURE__*/_react.default.createElement(_ImageCardCore.default, (0, _extends2.default)({}, props, {
      styles: _ImageCardModule.default,
      ref: ref
    })));
  }
});
var _default = exports.default = ImageCard;